import React from 'react';
import PropTypes from 'prop-types';
import classes from './CardTextA.module.scss';

const CardTextA = (props) => {
  const {
    heading,
    contentMarkup,
  } = props;

  return (
    <div className={classes.container}>
      {heading &&
        <h3
          className={classes.heading}
          dangerouslySetInnerHTML={{ __html: heading }}
        />}
      {contentMarkup &&
        <div
          className={classes.contentMarkup}
          dangerouslySetInnerHTML={{ __html: contentMarkup }}
        />}
    </div>
  );
};

CardTextA.propTypes = {
  /**
   * Heading on the card
  */
  heading: PropTypes.string,
  /**
   * Content of the card
  */
  contentMarkup: PropTypes.string,
};

export default CardTextA;
